



































import Vue from 'vue';
import _ from 'lodash';

import Requester from '../../requester';

export default Vue.extend({
  name: 'ThePacientesCadastroExternoEtapa1',
  data() {
    return {
      loading: false,
      valid: false,
      lastCpfError: '',
      form: {
        cpf: '',
      },
      errorMessages: {
        cpf: [] as string[],
      },
      rules: {
        cpf: [
          (v: string) => !!v || 'Campo obrigatório',
          (v: string) => (v && v.length === 14) || 'CPF incompleto',
          (v: string) => {
            const cpf: string = v.replace(/\D+/gm, '');
            if (cpf.length !== 11) {
              return 'CPF inválido';
            }
            let soma: number;
            let resto: number;
            if (Number(cpf) % 11111111111 === 0) {
              return 'CPF inválido';
            }
            soma = 0;
            for (let i = 1; i <= 9; i += 1) {
              soma += Number(cpf.substring(i - 1, i)) * (11 - i);
            }
            resto = (soma * 10) % 11;
            if ((resto === 10) || (resto === 11)) {
              resto = 0;
            }
            if (resto !== Number(cpf.substring(9, 10))) {
              return 'CPF inválido';
            }
            soma = 0;
            for (let i = 1; i <= 10; i += 1) {
              soma += Number(cpf.substring(i - 1, i)) * (12 - i);
            }
            resto = (soma * 10) % 11;
            if ((resto === 10) || (resto === 11)) {
              resto = 0;
            }
            if (resto !== Number(cpf.substring(10, 11))) {
              return 'CPF inválido';
            }
            return true;
          },
        ],
      },
    };
  },
  computed: {
    formEtapa1(): Vue & { validate: () => boolean, resetValidation: () => boolean } {
      return this.$refs.formEtapa1 as Vue & {
        validate: () => boolean,
        resetValidation: () => boolean
      };
    },
  },
  mounted() {
    const formStore = this.$store.getters.pacienteFormExternoEtapa1;
    if (!_.isEmpty(formStore)) {
      this.form.cpf = formStore.cpf || '';
    }
    this.formEtapa1.resetValidation();
  },
  methods: {
    voltar() {
      this.$store.dispatch('updatePacienteFormExternoEtapa1', this.form);
      this.$emit('voltar');
      this.formEtapa1.resetValidation();
    },
    async continuar() {
      this.$store.dispatch('updatePacienteFormExternoEtapa1', this.form);
      this.loading = true;
      if (!this.formEtapa1.validate()) {
        this.loading = false;
        return;
      }
      /* Evita resend do mesmo CPF */
      if (this.form.cpf === this.lastCpfError) {
        this.loading = false;
        return;
      }
      /* Valida CPF */
      try {
        const response = await Requester.paciente.validaCpf(this.form.cpf);
        if (response.errors.length > 0) {
          this.lastCpfError = this.form.cpf;
          this.errorMessages.cpf = response.errors;
        } else {
          this.errorMessages.cpf = [] as string[];
          this.$emit('etapaValida', this.form);
        }
      } catch (err) {
        this.$root.$emit('requestError', err);
      } finally {
        this.loading = false;
      }
    },
  },
});
